// impact-slideshow.js
// Dawn-safe Impact-style hero slider

window.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-impact-slideshow="true"]');
  if (!sections.length) return;

  sections.forEach(section => {
    const slides = Array.from(section.querySelectorAll('.impact-slide'));
    const dots = Array.from(section.querySelectorAll('[data-impact-dot]'));
    const prev = section.querySelector('.impact-nav--prev');
    const next = section.querySelector('.impact-nav--next');
    const container = section.querySelector('.impact-slideshow__inner');

    if (!slides.length || !container) return;

    let current = 0;
    const total = slides.length;
    const duration = parseInt(section.dataset.duration, 10) || 6000;
    const autoplay = section.dataset.autoplay === 'true';

    const setActive = index => {
      slides.forEach(s => s.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
      current = index;
    };

    const nextSlide = () => setActive((current + 1) % total);
    const prevSlide = () => setActive((current - 1 + total) % total);

    let timer = null;
    const startTimer = () => {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(nextSlide, duration);
    };
    const stopTimer = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    if (next) next.addEventListener('click', () => { stopTimer(); nextSlide(); startTimer(); });
    if (prev) prev.addEventListener('click', () => { stopTimer(); prevSlide(); startTimer(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.impactDot, 10);
        if (isNaN(idx)) return;
        stopTimer();
        setActive(idx);
        startTimer();
      });
    });

    // swipe
    let startX = 0;
    container.addEventListener('touchstart', e => {
      if (!e.touches[0]) return;
      startX = e.touches[0].clientX;
    });

    container.addEventListener('touchend', e => {
      if (!e.changedTouches[0]) return;
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) < 40) return;
      stopTimer();
      if (diff > 0) {
        prevSlide();
      } else {
        nextSlide();
      }
      startTimer();
    });

    // init
    setActive(0);
    startTimer();
  });
});
